import React from 'react';
import { useNavigate } from 'react-router-dom';

function ProductRange() {
  const navigate = useNavigate();

  const products = [
    {
      name: 'PLYWOOD',
      img: '/images/products/gallery01.jpg',
    },
    {
      name: 'HARDWARE',
      img: '/images/products/gallery10.jpg',
    },
    {
      name: 'HOME DECOR',
      img: '/images/products/gallery23.jpg',
    },
    {
      name: 'KITCHEN ACCESSORIES',
      img: '/images/products/gallery19.jpg',
    },
    {
      name: 'VENEERS',
      img: '/images/products/gallery24.jpg',
    },
    {
      name: 'PANLES',
      img: '/images/products/gallery14.jpg',
    },
  ];

  return (
    <section className="product-range-section">
      <div className="container">
        <div className="product-range-title-wrap">
          <h2 className="product-range-title">OUR PRODUCTS</h2>
          <div className="product-range-title-underline"></div>
        </div>
        <div className="product-range-grid">
          {products.map((product, idx) => (
            <div className="product-card" key={idx}>
              <div className="product-image-wrap">
                <img src={product.img} alt={product.name} className="product-image" />
              </div>
              <div className="product-name">{product.name}</div>
            </div>
          ))}
        </div>
        <div className="product-range-btn-wrap">
          <button className="product-range-btn" onClick={() => navigate('/products')}>View All Products</button>
        </div>
      </div>
    </section>
  );
}

export default ProductRange; 